module.exports = __webpack_public_path__ + "images/newerp_button3.1787648603550.png";